module.exports = __webpack_public_path__ + "static/media/thumbs-up.4e86aa00.svg";